<template>
  <div class="market-section-header">
    <div class="market-section-header__title">
      <component :is="embedded ? 'h2' : 'h1'" class="market-section-header__text">
        {{ title }}
      </component>
      <div class="market-section-header__counter">
        <template v-if="count === 1"> 1 Market </template>
        <template v-else> {{ count }} Markets </template>
      </div>
    </div>
  </div>
</template>

<script src="./market-section-header.js"></script>
<style src="./market-section-header.scss" lang="scss"></style>
